import React from 'react';
import GenericSetupPage from './GenericSetupPage';

const MissedVisitReasonPage = () => {
  const columns = [
    { key: 'code', label: 'Code' },
    { key: 'reason', label: 'Reason' },
    { key: 'description', label: 'Description' },
    { key: 'requiresAuth', label: 'Requires Auth' },
    { key: 'active', label: 'Active' },
  ];

  const initialData = [
    { id: '1', code: 'HOSP', reason: 'Patient Hospitalized', description: 'Patient admitted to hospital', requiresAuth: 'No', active: 'Yes' },
    { id: '2', code: 'NOHOME', reason: 'Patient Not Home', description: 'Patient was not at home during visit', requiresAuth: 'No', active: 'Yes' },
    { id: '3', code: 'REFUSED', reason: 'Patient Refused', description: 'Patient refused care', requiresAuth: 'Yes', active: 'Yes' },
    { id: '4', code: 'WEATHER', reason: 'Inclement Weather', description: 'Unsafe weather conditions', requiresAuth: 'No', active: 'Yes' },
    { id: '5', code: 'STAFF', reason: 'Staff Unavailable', description: 'No staff available for visit', requiresAuth: 'Yes', active: 'Yes' },
    { id: '6', code: 'DECEASED', reason: 'Patient Deceased', description: 'Patient passed away', requiresAuth: 'No', active: 'Yes' },
  ];

  return (
    <GenericSetupPage
      title="Missed Visit Reason"
      columns={columns}
      initialData={initialData}
      addButtonText="Add Reason"
    />
  );
};

export default MissedVisitReasonPage;
